import "./accountCancelView.scss";

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { i18n } from 'core/i18n';
const { formatText, FormattedText } = i18n;

import { OKCover } from 'commonsComponents/OKCover';
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import WizardError from 'components/commons/wizardError/wizardError';
import AccountCancelViewWizard from './components/accountCancelViewWizard/accountCancelViewWizard';
import NewCardDetails from '../contractsView/components/newCardDetails/newCardDetails';
import { CallMeBack } from 'components/callMeBack/callMeBack';
import PreLeaveModalComponent from 'components/preLeaveModalComponent/preLeaveModalComponent';
import { LoadingSection } from 'commonsComponents/loadingSection';

import accountCancelActions from 'actions/accountCancel';
import intervenersActions from 'actions/getAccountInterveners';

import { getBreadcrumb, getCardDetails } from './helpers/accountCancelViewHelper';
import { getTaggingErrorStep, taggingErrorStepRedirect } from "./helpers/tagging";

import { LOCAL_STATE, STATUSES } from './constants';
import AccountCancelViewSuccess from './components/accountCancelViewSuccess/accountCancelViewSuccess';
import { CANCEL_FLOW_MODAL } from "./constants/tagging";

function AccountCancelView(props) {
    const {
        history,
        immAccounts,
        immAccountCancel,
        immFlagBasedFeatures,
        immProfile,
        accountCancelMotiveInputChanged,
        accountCancelMotiveSelectChanged,
        match: { params: { accountId } },
        validateStep,
        setAccountId,
        setVisibleStep,
        setPreLeaveModal,
        setPreLeaveIsPersonalData,
        resetAccountCancelState,
        requestCancelAccount
    } = props;
    const immAccount = immAccounts.get('byId').get(accountId);
    const interveners = immAccount.get('interveners');
    useEffect(() => {
        const interveners = immAccount.get('interveners');

        if (interveners.get('error')) {
            return;
        }

        if (!interveners || (!interveners.get('fetchSuccess') && !interveners.get('isLoading'))) {
            history.push('/myprofile/accounts');
        }
    }, []);

    useEffect(() => {
        accountId && setAccountId(accountId);
    }, [])

    useEffect(() => {
        return () => {
            resetAccountCancelState();
        }
    }, []);

    const getWizardContent = () => {
        const interveners = immAccount.get('interveners');
        const wizardState = Immutable.fromJS({
            promotionalCode: "",
            interveners: interveners.get('list'),
            card_details: getCardDetails(immAccount, immAccountCancel, immProfile),
            name: "cancel-account",
            visibleStep: immAccountCancel.get('currentStep'),
        });
        const isPreLeavePersonalData = immAccountCancel.get('isPreLeavePersonalData');
        const confirmationMessage = isPreLeavePersonalData ? 
            "cancellation_account-cancellation_account_exit_process_description" : 
            "wizard-redirectConfirmationMessage";
        const confirmationTitle = isPreLeavePersonalData ? 
            "cancellation_account-cancellation_account_exit_process_title" : 
            "wizard-redirectConfirmationTitle";
        const acceptText = isPreLeavePersonalData ? 
            "cancellation_account-cancellation_account_exit_process_exit_button" : 
            "wizard-redirectConfirmationAcceptButton";
        const cancelText = isPreLeavePersonalData ? 
            "wizard-redirectConfirmationCancelButton" : 
            "wizard-redirectConfirmationCancelButton";
        const localState = LOCAL_STATE;
        return <React.Fragment>
            <div className="col-xs-12 col-md-8">
                <AccountCancelViewWizard
                    immAccountCancel={immAccountCancel}
                    immAccount={immAccount}
                    immProfile={immProfile}
                    accountCancelMotiveSelectChanged={accountCancelMotiveSelectChanged}
                    accountCancelMotiveInputChanged={accountCancelMotiveInputChanged}
                    validateStep={validateStep}
                    requestCancelAccount={requestCancelAccount}
                    setVisibleStep={setVisibleStep}
                    setPreLeaveModal={setPreLeaveModal}
                    setPreLeaveIsPersonalData={setPreLeaveIsPersonalData}
                    history={history}
                />
            </div>
            <div className="col-xs-12 col-md-4">
                <div className="col-xs-6 col-md-12 grid-view--variable-cell-separation">
                    <div>
                        <NewCardDetails
                            alternativeInterveners
                            clearInterveners={() => { }}
                            immCommercialAds={{}}
                            immHireCardImageSelector={{}}
                            immProfileFields={immProfile}
                            immFlagBasedFeatures={immFlagBasedFeatures}
                            originCountry={immProfile.get('originCountry')}
                            wizardState={wizardState}
                            localState={localState}
                        />
                    </div>
                </div>
                <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                    <CallMeBack context="contracts" modifier="contracts-view" pageTitle={formatText('cancellation_account-account_cancellation_request_main_flow_title')} />
                </div>
            </div>
            <PreLeaveModalComponent
                confirmationMessage={confirmationMessage}
                confirmationTitle={confirmationTitle}
                acceptText={acceptText}
                cancelText={cancelText}
                footerType="navigation"
                taggingEvents={isPreLeavePersonalData && CANCEL_FLOW_MODAL}
                isReady={() => {
                    return false
                }}
                onCloseCallback={() => setPreLeaveIsPersonalData(false)}
            />
        </React.Fragment>
    }

    const getErrorContent = () => {
        const url = `/myprofile/accounts/${accountId}/movements`;

        const errorSubMessage = <div className="account-cancel-view__error-sub-message">
            <FormattedText value="cancellation_account-account_cancellation_request_error_description" />
        </div>
        return (
            <div className="account-cancel-view__error">
                <WizardError
                    isSecondVersion
                    tealium={getTaggingErrorStep(immAccount)}
                    errorMessage={formatText('cancellation_account-account_cancellation_request_error_title')}
                    errorSubMessage={errorSubMessage}
                    doMainButtonCustomEvent={() => taggingErrorStepRedirect(url)}
                    mainButton={{
                        label: formatText('cancellation_account-account_cancellation_request_failure_accounts_navigation'),
                        url
                    }}
                >
                </WizardError>
            </div>
        );
    }

    let content;
    const status = interveners.get('isLoading') ? STATUSES.FETCHING : immAccountCancel.get('status');

    switch (status) {
        case STATUSES.FETCHING:
            content = <LoadingSection />
            break;
        case STATUSES.IDLE:
        case STATUSES.SAVING:
            content = interveners?.get('list')?.size && getWizardContent();
            break;
        case STATUSES.ERROR:
            content = getErrorContent();
            break;
        case STATUSES.SAVED:
            content = <AccountCancelViewSuccess immProfile={immProfile} immAccount={immAccount} />
        default:
            break;
    }

    return <div className="account-cancel-view">
        <div className="container-fluid">
            <div>
                <div className="row">
                    <OKCover size="small" section="accounts" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={getBreadcrumb(immAccount)}
                            finalTitle={formatText('cancellation_account-account_cancellation_request_main_flow_title')}
                        />
                    </OKCover>
                </div>
                <div className="grid-view__body deposits-renovations-cancel-account__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative deposits-renovations-cancel-account__content-position-negative">
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

AccountCancelView.propTypes = {
    immAccountCancel: PropTypes.instanceOf(Immutable.Map).isRequired,
    immProfile: PropTypes.instanceOf(Immutable.Map).isRequired,
    immFlagBasedFeatures: PropTypes.instanceOf(Immutable.Map).isRequired,
    immAccounts: PropTypes.instanceOf(Immutable.Map).isRequired,
    accountCancelMotiveSelectChanged: PropTypes.func.isRequired,
    accountCancelMotiveInputChanged: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setAccountId: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setPreLeaveModal: PropTypes.func.isRequired,
    setPreLeaveIsPersonalData: PropTypes.func.isRequired,
    resetAccountCancelState: PropTypes.func.isRequired,
};


const mapStateToProps = state => ({
    immAccountCancel: state.accountCancel,
    immProfile: state.profile,
    immFlagBasedFeatures: state.flagBasedFeatures,
    immAccounts: state.accounts,
});

export const ConnectedAccountCancelView = connect(mapStateToProps, {
    accountCancelMotiveSelectChanged: accountCancelActions.accountCancelMotiveSelectChanged,
    accountCancelMotiveInputChanged: accountCancelActions.accountCancelMotiveInputChanged,
    requestInterveners: intervenersActions.requestAccountInterveners,
    validateStep: accountCancelActions.validateStep,
    setAccountId: accountCancelActions.setAccountId,
    setVisibleStep: accountCancelActions.setVisibleStep,
    setPreLeaveModal: accountCancelActions.setPreLeaveModal,
    setPreLeaveIsPersonalData: accountCancelActions.setPreLeaveIsPersonalData,
    resetAccountCancelState: accountCancelActions.resetAccountCancelState,
    requestCancelAccount: accountCancelActions.requestCancelAccount,
})(AccountCancelView);
export { ConnectedAccountCancelView as AccountCancelView };
